// Derives a canonical `variant` string for the compta product resolver.
// Values must match metadata->>'variant' tags on compta.products
// (see migration M1 in spec 2026-05-20-booking-activity-link-design.md):
//   'sunrise' | 'sunset' for paramotor/balloon
//   'half_day' | 'full_day' | '2_day' | '6_day' for enduro
//   null for 1:1 products (treks, tuktuk, cruise)

export type Variant =
  | 'sunrise'
  | 'sunset'
  | 'half_day'
  | 'full_day'
  | '2_day'
  | '6_day'
  | null

export function deriveVariant(input: {
  timeSlot?: string
  tourType?: string
}): Variant {
  const ts = input.timeSlot?.trim().toLowerCase()
  if (ts === '05:30' || ts === 'sunrise') return 'sunrise'
  if (ts === '16:00' || ts === 'sunset') return 'sunset'

  // Normalise tourType too — be tolerant of casing/whitespace from any caller.
  const tt = input.tourType?.trim().toLowerCase()
  if (
    tt === 'half_day' ||
    tt === 'full_day' ||
    tt === '2_day' ||
    tt === '6_day'
  )
    return tt

  return null
}
